module.exports = __webpack_public_path__ + "static/media/add-more.6614e534.svg";